// TODO quick-and-easy copy-pasta from home.js; make this a proper error page
// TODO also make other error pages (at least 403 and 500)
import React, { useState, useEffect } from 'react'
import { Typography } from 'antd'

const { Title } = Typography

const NotFound = () => {

  const words = [
    { text: "NOT FOUND", color: "#ff6b6b" },    // Red
    { text: "NOT FOUND", color: "#4ecdc4" },    // Turquoise
    { text: "NOT FOUND", color: "#5bc0de" },   // Light Cyan (was #45b7d1)
    { text: "NOT FOUND", color: "#96c93d" },    // Lime Green
    { text: "NOT FOUND", color: "#e0a824" },  // Deeper Gold (was #f7b731)
    { text: "NOT FOUND", color: "#e65c00" },    // Orange-Red (was #e74c3c)
    { text: "NOT FOUND", color: "#3498db" },    // Bright Blue
    { text: "NOT FOUND", color: "#2ecc71" },     // Emerald Green
    { text: "NOT FOUND", color: "#e67e22" },    // Orange
    { text: "NOT FOUND", color: "#8e44ad" },    // Deep Purple
    { text: "NOT FOUND", color: "#1abc9c" },   // Teal
    { text: "NOT FOUND", color: "#d35400" },   // Pumpkin
    { text: "NOT FOUND", color: "#27ae60" },    // Forest Green
    { text: "NOT FOUND", color: "#c0392b" },    // Dark Red
    { text: "NOT FOUND", color: "#16a085" },    // Dark Teal
    { text: "NOT FOUND", color: "#e6b800" },    // Darker Yellow (was #f1c40f)
    { text: "NOT FOUND", color: "#8c7ae6" },    // Soft Purple
    { text: "NOT FOUND", color: "#e84393" },     // Magenta
    { text: "NOT FOUND", color: "#9b59b6" }     // Muted Purple
  ]

  const [currentIndex, setCurrentIndex] = useState(-1)
  const [isCycling, setIsCycling] = useState(true)

  useEffect(() => {

    let intervalId

    if (isCycling) {

      intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => {

          const nextIndex = prevIndex + 1

          if (nextIndex >= words.length) {

            setIsCycling(false)
            return Math.floor(Math.random() * words.length)
          }

          return nextIndex
        })
      }, 100)

    } else {

      intervalId = setTimeout(() => {
        setIsCycling(true)
        setCurrentIndex(-1)
      }, 5000)
    }

    return () => {

      if (intervalId) isCycling ? clearInterval(intervalId) : clearTimeout(intervalId)
    }
  }, [isCycling])

  return (
    <Title style={{
      alignItems: 'center',
      display: 'flex',
      fontSize: '6rem',
      fontWeight: 'bold',
      fontFamily: 'Arial, sans-serif',
      height: '250px'
    }}>
      <span style={{ marginRight: '25px', textWrap: "nowrap" }}>404</span>
      {currentIndex >= 0 && (
        <span style={{
          color: words[currentIndex].color,
          transition: 'color 0.1s ease, text-shadow 0.3s ease'
        }}>
          {words[currentIndex].text}
        </span>
      )}
    </Title>
  )
}

export default NotFound